import {selectSessionUser} from "../../../../../store/authentication/selectors";
import React, {useEffect, useState, createContext} from "react";
import {useHistory, useLocation} from "react-router";
import {useSelector} from "react-redux";
import constants from "../../../../../config/constants";
import * as io from "socket.io-client";
import Box from "@mui/material/Box";

import "../BoardGame.css";
import Button from "@mui/material/Button";
import ConfirmModal from "../terraforming/utils/Modal";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import {Collapse} from "@mui/material";
import {DiceComponent} from "./components/DiceComponent";
import {ConsultCardScreen} from "./components/ConsultCardScreen";
import {BoardComponent} from "./components/BoardComponent";
import {ResourcesComponent} from "./components/ResourcesComponent";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {HelpComponent} from "./help/Help";

// Create context to pass state to child components
export const GameStateContext = createContext({
    state: {cardSelectionActions: [], squareLatticeActions: []},
    setState: () => {
    }
});


export const GeneratedHome = () => {

    const [state, setState] = useState({
        state: undefined,
        play: true,
        checkNewState: false,
        action: undefined,
        show: false
    });
    const [expandedGroup, setExpandedGroup] = useState(null);

    const [connected, setConnected] = useState(false);

    const [gameData, setGameData] = useState(null);

    const [historics, setHistorics] = useState([]);

    // New: help panel open/close state
    const [helpOpen, setHelpOpen] = useState(false);

    const user = useSelector(selectSessionUser);

    const history = useHistory();
    const location = useLocation();

    const gameId = location.pathname.split("/")[3];
    const game = location.pathname.split("/")[2];

    let [socket, setSocket] = useState(undefined);

    // Extract special actions in its own state to avoid rendering issues
    const [cardSelectionActions, setCardSelectionActions] = useState([]);
    const [boardChoices, setBoardChoices] = useState({});
    const [diceActions, setDiceActions] = useState([]);
    const [remainingActions, setRemainingActions] = useState([]);

    // Effect to update cardSelectionActions when actions change
    useEffect(() => {
        if (state.state && state.state.actions && state.state.actions[user._id]) {
            const choices = state.state.actions[user._id];
            const cardSelectionActions = [];
            const boardChoices = {};
            const diceActions = [];
            const remainingActions = [];
            choices.forEach(choice => {
                if (choice.class === "model.action.special.ActionSelectCards") {
                    cardSelectionActions.push(choice);
                } else if (["PlacePieceChoice", "MovePieceChoice", "MoveSequencePieceChoice", "SelectColumnChoice", "SelectCaseChoice"].includes(choice.type)) {
                    const boardName = choice.boardName;
                    if (!boardChoices[boardName]) {
                        boardChoices[boardName] = [];
                    }
                    boardChoices[boardName].push(choice);
                } else if (choice.type === "RollDiceChoice") {
                    diceActions.push(choice);
                } else {
                    remainingActions.push(choice);
                }
            });
            setCardSelectionActions(cardSelectionActions);
            setBoardChoices(boardChoices);
            setDiceActions(diceActions);
            setRemainingActions(remainingActions);
        } else {
            setCardSelectionActions([])
        }
    }, [state.state?.actions, user._id]);

    function updateState(newState) {
        setState(state => {
            if (newState && (newState.state !== "INTRO" || !state.state)) {
                let {play, checkNewState} = state;
                if (play && (!newState.actions || !newState.actions[user._id] || !newState.actions[user._id].length)) {
                    play = false;
                    checkNewState = false;
                } else if (!play && newState.actions && newState.actions[user._id] && newState.actions[user._id].length && !checkNewState) {
                    play = true;
                    checkNewState = true;
                }
                return {...state, state: newState, play, checkNewState};
            }
            return state;
        });
    }

    function updateStateIntro(newState) {
        setState(state => !state.state || state.state.state === "INTRO" ? {...state, state: newState} : state);
    }

    useEffect(() => {
        const tempSocket = io.connect(constants.api.socketPath);
        tempSocket.on('disconnect', function () {
            history.push("/board-games");
        });
        tempSocket.on('state', function (data) {
            console.log('new state');
            console.log(data);
            updateState(data);
        });
        tempSocket.on('state_intro', function (data) {
            updateStateIntro(data);
        });
        tempSocket.on('game-data', function (data) {
            setGameData(data);
        });
        tempSocket.on('historics', function(data) {
            setHistorics(data);
        });
        setSocket(tempSocket);
        setTimeout(() => {
            if (socket && !socket.connected) {
                history.push("/board-games");
            }
        }, 3000);
        return () => {
            tempSocket.close();
        }
    }, []);

    useEffect(() => {
        if (user && !!socket && !connected) {
            socket.emit("id", {
                type: "PLAYER",
                gameId,
                userId: "" + user._id,
                username: user.username,
                color: localStorage.getItem("generated-color")
            });
            setConnected(true);
        }
    }, [user, socket]);


    let comp = undefined;

    // ColorSelector component for color selection
    function ColorSelector({user, socket, gameId}) {
        const colorOptions = ["blue", "red", "green", "orange", "purple", "yellow"];
        const [selectedColor, setSelectedColor] = useState(localStorage.getItem("generated-color"));

        const handleColorChange = (color) => {
            setSelectedColor(color);
            localStorage.setItem("generated-color", color);
            if (user && socket) {
                socket.emit("id", {
                    type: "PLAYER",
                    gameId,
                    userId: "" + user._id,
                    username: user.username,
                    color: color
                });
            }
        };

        return <div style={{
            marginTop: 30,
            marginBottom: 10,
            fontSize: 16,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        }}>
            Choisissez votre couleur :
            <div style={{display: 'flex', gap: 12, marginTop: 10}}>
                {colorOptions.map(color => (
                    <button
                        key={color}
                        onClick={() => handleColorChange(color)}
                        style={{
                            width: 36,
                            height: 36,
                            borderRadius: '50%',
                            border: selectedColor === color ? '3px solid #FFF' : '2px solid #888',
                            background: color,
                            outline: 'none',
                            cursor: 'pointer',
                            boxShadow: selectedColor === color ? '0 0 8px #FFF' : undefined
                        }}
                        aria-label={color}
                    />
                ))}
            </div>
        </div>;
    }

    if (!state.state || !socket) {
        return null;
    }

    const toggleGroup = (groupLabel) => {
        if (expandedGroup === groupLabel) {
            setExpandedGroup(null);
        } else {
            setExpandedGroup(groupLabel);
        }
    };

    const renderAction = (action) => {
        let actionComp = <span>{action.type}</span>;
        if (action.type === "GainResourceChoice" || action.type === "GiveResourceToPlayerChoice" || action.type === "TakeResourceFromPlayerChoice" || action.type === "LooseResourceChoice") {
            const baseImageUrl = constants.api.basePath + "/generated/" + game + "/image";
            let resources = {};
            let startSentence = undefined;
            let endSentence = undefined;
            if(action.type === "GiveResourceToPlayerChoice"){
                resources = action.resourcesToGive;
                startSentence = <span>Donner</span>
                endSentence = <span>à {Object.values(state.state.players).filter(p => p.playerId === action.targetPlayerId)[0]?.username || "Joueur"}</span>
            } else if(action.type === "TakeResourceFromPlayerChoice"){
                resources = action.resourcesToTake;
                startSentence = <span>Prendre</span>
                endSentence = <span>à {Object.values(state.state.players).filter(p => p.playerId === action.targetPlayerId)[0]?.username || "Joueur"}</span>
            } else if(action.type === "GainResourceChoice"){
                resources = action.resourcesToGain;
                startSentence = <span>Gagner</span>;
            } else if(action.type === "LooseResourceChoice"){
                resources = action.resourcesToLoose;
                startSentence = <span>Dépenser</span>;
            }
            actionComp = (
                <span style={{display: 'inline-flex', alignItems: 'center', gap: 6}}>
                    {startSentence}
                    {resources && Object.entries(resources).map(([field, qty]) => (
                        <span key={field} style={{display: 'inline-flex', alignItems: 'center', gap: 3}}>
                            <span style={{fontWeight: 600}}>{qty}</span>
                            <img
                                src={`${baseImageUrl}?imagePath=icon_${field}.png`}
                                alt={field}
                                style={{width: 32, height: 32, objectFit: 'contain'}}
                            />
                        </span>
                    ))}
                    {endSentence}
                </span>
            );
        } else if (action.type === "TradeResourceChoice") {
            const baseImageUrl = constants.api.basePath + "/generated/" + game + "/image";
            actionComp = (
                <span style={{display: 'inline-flex', alignItems: 'center', justifyContent: 'flex-start', gap: '6px'}}>
                    Echanger
                    {/* Render each resource to lose with its icon and quantity */}
                    {action.resourcesToPay && Object.entries(action.resourcesToPay).map(([field, qty]) => (
                        <span key={field} style={{display: 'inline-flex', alignItems: 'center', gap: 3}}>
                            <span style={{fontWeight: 600}}>{qty}</span>
                            <img
                                src={`${baseImageUrl}?imagePath=icon_${field}.png`}
                                alt={field}
                                style={{width: 32, height: 32, objectFit: 'contain'}}
                            />
                        </span>
                    ))}
                    contre
                    {action.resourcesToGain && Object.entries(action.resourcesToGain).map(([field, qty]) => (
                        <span key={field} style={{display: 'inline-flex', alignItems: 'center', gap: 0}}>
                            <span style={{fontWeight: 600}}>{qty}</span>
                            <img
                                src={`${baseImageUrl}?imagePath=icon_${field}.png`}
                                alt={field}
                                style={{width: 32, height: 32, objectFit: 'contain'}}
                            />
                        </span>
                    ))}
                </span>
            );
        }
        return <div key={action.type + action.confirmationMessage} style={{
            width: '100%',
            backgroundColor: "#2a2d4a",
            borderRadius: "8px",
            display: "flex",
            marginBottom: "8px",
            padding: "10px 15px",
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            transition: 'all 0.2s ease',
            boxSizing: 'border-box',
        }}>
            <div style={{flex: 1, fontSize: "16px"}}>
                {actionComp}
            </div>
            <div>
                <Button
                    variant={"contained"}
                    disabled={!action.ok}
                    onClick={() => setState(state => ({...state, action, show: true}))}
                    sx={{minWidth: '80px'}}
                >
                    Choisir
                </Button>
            </div>
        </div>;
    };

    const renderActionGroup = () => {
        // Get all actions for the current user
        const actions = remainingActions || [];

        // Filter out ActionSelectCards actions - they will be passed to card consult screens
        const regularActions = actions.filter(action => action.class !== "model.action.special.ActionSelectCards");

        // Group actions by label
        const groupedActions = {};
        const actionsToRenderDirectly = [];

        regularActions.forEach(action => {
            if (action.label) {
                if (!groupedActions[action.label]) {
                    groupedActions[action.label] = [];
                }
                groupedActions[action.label].push(action);
            } else {
                actionsToRenderDirectly.push(action);
            }
        });

        // Move groups with only one action to direct rendering
        Object.keys(groupedActions).forEach(label => {
            if (groupedActions[label].length === 1) {
                actionsToRenderDirectly.push(groupedActions[label][0]);
                delete groupedActions[label];
            }
        });

        return (
            <>
                {/* Render direct actions (unlabeled + single-action groups) */}
                {actionsToRenderDirectly.map(renderAction)}

                {/* Render labeled action groups (only those with multiple actions) */}
                {Object.keys(groupedActions).map(label => (
                    <div key={label} style={{marginBottom: "12px"}}>
                        <div
                            onClick={() => toggleGroup(label)}
                            style={{
                                backgroundColor: "#1f2136",
                                borderRadius: "10px",
                                padding: "12px 15px",
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                transition: 'background-color 0.2s ease',
                                fontWeight: "500",
                                fontSize: "17px",
                                justifyContent: "space-between"
                            }}
                        >
                            <div style={{display: "flex", alignItems: "center"}}>
                                {expandedGroup === label ?
                                    <ArrowDropDownIcon style={{marginRight: "5px"}}/> :
                                    <ArrowRightIcon style={{marginRight: "5px"}}/>
                                }
                                {label} ({groupedActions[label].length})
                            </div>
                        </div>
                        <Collapse in={expandedGroup === label} timeout="auto">
                            <div style={{paddingLeft: "20px", paddingTop: "10px"}}>
                                {groupedActions[label].map(renderAction)}
                            </div>
                        </Collapse>
                    </div>
                ))}
            </>
        );
    };

    const playersWithoutColors = state.state.networkPlayers ? state.state.networkPlayers.filter(p => !p.color) : [];
    const nbPlayers = state.state.networkPlayers ? state.state.networkPlayers.length : 0;

    const colors = {};
    state.state.networkPlayers ? state.state.networkPlayers.filter(p => p.color).forEach(p => {colors[p.color] = (colors[p.color] || 0) + 1}) : undefined;

    const canStartGame = nbPlayers >= state.state.minPlayers && nbPlayers <= state.state.maxPlayers && playersWithoutColors.length === 0 && Math.max(...Object.values(colors)) <= 1;

    switch (state.state && state.state.state) {
        case "INTRO":
            const startButton = <div style={{marginTop: 20}}>
                <Button variant="contained"
                        disabled={!canStartGame}
                        onClick={() => socket.emit("start_game", "")}>
                    Démarrer la partie
                </Button>
            </div>
            let startAdvice = undefined;
            if (nbPlayers < state.state.minPlayers) {
                startAdvice = <span>Il faut au moins {state.state.minPlayers} joueurs pour démarrer la partie.</span>;
            } else if (nbPlayers > state.state.maxPlayers) {
                startAdvice = <span>Il y a trop de joueurs ({nbPlayers}). Le maximum est de {state.state.maxPlayers}.</span>;
            } else if (playersWithoutColors.map(p => p.username).indexOf(user.username) > -1) {
                startAdvice = <span>Vous devez choisir une couleur.</span>
            } else if (playersWithoutColors.length > 1) {
                startAdvice = <span>{playersWithoutColors.map(p => p.username).join(" et ")} doivent choisir une couleur.</span>
            } else if (playersWithoutColors.length === 1) {
                startAdvice = <span>{playersWithoutColors.map(p => p.username)[0]} doit choisir une couleur.</span>
            } else if (Math.max(...Object.values(colors)) > 1) {
                startAdvice = <span>{state.state.networkPlayers.filter(p => p.color && colors[p.color] > 1).map(p => p.username).join(" et ")} ont la même couleur.</span>
            }
            return <div style={{
                width: "100%",
                height: "100%",
                marginTop: "15vh",
                marginBottom: "80vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
            }}>
                Veuillez attendre que la partie démarre
                <ColorSelector user={user} socket={socket} gameId={gameId}/>
                {startButton}
                {
                    startAdvice ?
                    <div style={{margin: "8px auto", width: "80%", maxWidth: "400px", textAlign: "center", color: "gray"}}>
                    {startAdvice}
                    </div>: undefined
                }
            </div>;
        default:
            comp = <div>
                <div style={{flex: 5, marginLeft: "5%", width: "95%"}}>
                    {renderActionGroup()}
                </div>
            </div>;
    }

    if (state.state.actions[user._id] && state.state.actions[user._id][0] && state.state.actions[user._id][0].class === "model.action.special.ActionRollDice") {
        comp = <div>
            <div style={{flex: 1, fontSize: "20px", margin: '3vh 0', alignItems: "center", display: "flex"}}>
                C'est à vous de lancer !
            </div>
            <div style={{flex: 5, margin: "0 auto 32px", width: "70vw", height: "70vw"}}>
                <DiceComponent nbDices={state.state.actions[user._id][0].nbDices || 1} callback={(x, y, vx, vy) => {
                    const rollDiceAction = state.state.actions[user._id][0];
                    rollDiceAction.x = x;
                    rollDiceAction.y = y;
                    rollDiceAction.vx = vx;
                    rollDiceAction.vy = vy;
                    socket.emit("action", rollDiceAction);
                }}>

                </DiceComponent>
            </div>

        </div>
    }


    let modal = <ConfirmModal
        action={state.show ? state.action : undefined}
        text={state.action ? state.action.confirmationMessage + " ?": ""}
        socket={socket}
        onDismiss={() => setState(state => ({...state, action: undefined, show: false}))}
        open={state.show}
    />;

    // Get card consult screens for the current player
    const cardConsultScreens = state.state.consultScreens && state.state.consultScreens[user._id]
        ? state.state.consultScreens[user._id].filter(screen => screen.class === "model.network.ConsultCardScreen")
        : [];

    // Create context value with cardSelectionActions
    const contextValue = {
        state: {cardSelectionActions, squareLatticeActions: boardChoices},
        setState
    };

    const currentPlayerIds = (state.state && state.state.actions
        ? Object.keys(state.state.actions).filter(playerId => state.state.actions[playerId] && state.state.actions[playerId].length > 0)
        : []);

    return <div style={{width: "100%", minHeight: "90vh", marginTop: "-1px"}}>
        {modal}

        {/* Turn status badge - positioned at the top */}
        <div style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            padding: "15px 0",
            zIndex: 100
        }}>
            <div style={{
                backgroundColor: state.state.actions[user._id] && state.state.actions[user._id].length ? "#1f70ea" : "#10346f",
                color: "white",
                padding: "10px 20px",
                width: "100%",
                boxSizing: "border-box",
                fontWeight: "bold",
                boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                fontSize: "16px",
                textAlign: "center",
                minWidth: "150px"
            }}>
                {state.state.actions[user._id] && state.state.actions[user._id].length ?
                    "À vous de jouer" :
                    "En attente"
                }
            </div>
        </div>

        {
            state.play ?
                <Box className="board-game" sx={{width: {xs: "80%", md: "50%"}}}>
                    <div style={{flex: 1, fontSize: "20px", margin: '3vh 0', alignItems: "center", display: "flex"}}>
                        Que souhaitez-vous faire ?
                    </div>
                    <GameStateContext.Provider value={contextValue}>
                        {cardConsultScreens.map((screen, index) => (
                            <ConsultCardScreen key={`card-screen-${index}`} screen={screen} gameId={game}/>
                        ))}
                        {
                            Object.keys(boardChoices).map(boardName =>
                                <BoardComponent
                                    key={boardName}
                                    gameId={game}
                                    players={state.state.players}
                                    board={state.state.boards[boardName]}
                                    actions={boardChoices[boardName]}
                                />
                            )
                        }
                    </GameStateContext.Provider>
                    {
                        diceActions.map((action, index) =>
                            <div style={{flex: 5, margin: "auto", width: "70vw", height: "70vw"}}>
                                <DiceComponent
                                    key={`dice-action-${index}`}
                                    nbDices={action.nbDices || 1}
                                    callback={(x, y, vx, vy) => {
                                        action.x = x;
                                        action.y = y;
                                        action.vx = vx;
                                        action.vy = vy;
                                        socket.emit("action", action);
                                    }}
                                />
                            </div>
                        )
                    }
                    {
                        comp || JSON.stringify(state.state)
                    }
                </Box>
                : <div style={{
                    width: "80%",
                    margin: "20px auto",
                    textAlign: "center",
                    padding: "20px"
                }}>
                    Veuillez attendre votre tour
                <br/>
                <br/>
                    {
                        currentPlayerIds.length === 1 ?
                        <span style={{color: "gray"}}>C'est à {state.state.players[currentPlayerIds[0]].username} de jouer</span>: undefined
                    }
                </div>
        }
        <ResourcesComponent player={state.state.players[user._id]} gameId={game}/>

        {/* Floating help button bottom-right */}
        <button
            aria-label="Aide"
            onClick={() => setHelpOpen(true)}
            style={{
                position: 'fixed',
                right: 0,
                bottom: 72,
                background: '#1f70ea',
                color: '#fff',
                border: 'none',
                padding: 12,
                margin: 0,
                borderRadius: '28px 0 0 28px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                zIndex: 1100
            }}
        >
            <HelpOutlineIcon style={{ color: '#fff' }} fontSize="small" />
        </button>

        {/* Full-screen slide-in help panel */}
        <div
            aria-hidden={!helpOpen}
            style={{
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                zIndex: 1400,
                background: helpOpen ? 'rgba(0,0,0,0.45)' : 'rgba(0,0,0,0)',
                opacity: helpOpen ? 1 : 0,
                pointerEvents: helpOpen ? 'auto' : 'none',
                transition: 'opacity 200ms ease, background 200ms ease'
            }}
            onClick={() => setHelpOpen(false)}
        >
            <div
                role="dialog"
                aria-label="Aide"
                onClick={(e) => e.stopPropagation()}
                style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    transform: helpOpen ? 'translateX(0)' : 'translateX(100%)',
                    transition: 'transform 240ms ease',
                    height: "100%",
                    overflowX: "hidden",
                    overflowY: "auto",
                    background: '#0f1224'
                }}
            >
                <HelpComponent
                    gameData={gameData}
                    gameId={game}
                    socket={socket}
                    historics={historics}
                    onClose={() => setHelpOpen(false)}
                />
            </div>
        </div>
    </div>;
};

export default GeneratedHome;
